<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col-md-6">
          <label for="point_name" class="form-control-label">
            Nombre<span class="required">*</span>
          </label>
          <input
            id="point_name"
            v-model="formModel.name"
            :class="[
                          'form-control',
                          v.name.$error ? 'is-invalid' : '',
                        ]"
            type="text"
            placeholder=""
          />
          <p v-if="v.name.$error" class="invalid-feedback mb-0">
            <small>
              {{ v.name.$errors[0].$message }}
            </small>
          </p>
          <label for="trail" class="form-control-label w-100">
            Ruta<span class="required">*</span>
          </label>
          <el-select
              v-model="formModel.trail"
              size="large"
              class="w-100"
          >
            <el-option
                v-for="selectItem in trails"
                :key="selectItem.id"
                :value="selectItem.id"
                :label="selectItem.name"
            />
          </el-select>
          <p v-if="v.trail.$error" class="invalid-feedback mb-0">
            <small>
              {{ v.trail.$errors[0].$message }}
            </small>
          </p>
        </div>
        <div class="col-md-6">
          <div class="card">
              <div class="card-header">
                <h5 class="card-title"> Puntos de interés</h5>
                <button class="btn btn-primary btn-sm" @click.prevent="showAddForm()" :disabled="!formModel.id">Agregar Punto</button>
              </div>
            <div class="card-body">
              <ul class="list-unstyled" v-if="points.length">
                <li class="row">
                  <div class="col-md-6 text-bold">
                    Nombre
                  </div>
                  <div class="col-md-2 text-bold">
                    <span class="text-sm ml-2">Tipo</span>
                  </div>
                  <div class="col-md-4"></div>
                </li>
                <li class="row mrow" v-for="point in points" :key="point.id">
                  <div class="col-md-6">
                    {{ point.name }}
                  </div>
                  <div class="col-md-2">
                    <span class="text-sm ml-2" v-if="point.type">{{ point.type.name }}</span>
                  </div>
                  <div class="col-md-4">
                    <div class="w-100 pointrow">
                      <a   v-if="point.id"  @click.prevent="showEdit(point)"
                          class="btn btn-link  px-3 mb-0">
                        <i class="fa fa-pencil text-dark" style="margin-left: auto;"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a
                          class="btn btn-link text-danger text-gradient px-3 mb-0"
                          href="javascript:;"
                          @click="handleDelete(point)"
                      >
                        <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
              <el-dialog style="width: 50%;" class="dd" v-model="showEditFom" title="Editar Punto de interés">
                <point-add-form action="update" :entity="selectedPoint" @updatePoint="updatePoint" @setLoadingPoint="setLoadingPoint" @hideAddForm="hideAddForm" :parent="entity"/>
              </el-dialog>
              <el-dialog class="dd" v-model="showAddFom" title="Agregar Punto de interés">
                <point-add-form action="create" :entity="newPoint" @addPoint="addPoint" @setLoadingPoint="setLoadingPoint" @hideAddForm="hideAddForm" :parent="entity"/>
              </el-dialog>

            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="post_photo" class="form-control-label">
            Imagen<span class="required">*</span>
          </label>
          <el-upload
              class="upload-demo"
              drag
              :action="imagesUrl"
              :on-success="imageUploaded"
              :on-remove="handleImageRemove"
              v-model:file-list="imageFileList"
              list-type="picture"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              Arrastre aquí <em>click para subir archivos</em>
            </div>
            <template #tip>
              <!-- <div class="el-upload__tip">
                jpg/png files with a size less than 500kb
              </div>-->
            </template>
          </el-upload>
          <p v-if="v.image.$errors.length" class="invalid-feedback mb-0">
            <small>
              {{ v.image.$errors[0].$message }}
            </small>
          </p>
        </div>
      </div>
      <div class="mt-3">
        <button
            :disabled="loading"
            type="submit"
            class="float-end btn btn-primary text-white bg-blue-600 rounded-lg border border-primary hover:bg-blue-900">
            {{ buttonText }}
        </button>
        <button
          class="me-2 float-end btn btn-primary text-danger bg-white border border-danger rounded-lg hover:bg-blue-900"
          @click="handleCancel"
        >
          Cancelar
        </button>
      </div>
    </form>

    <!-- overlay de carga -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
      <p>Subiendo video, espera un momento...</p>
    </div>
  </div>
</template>

<script setup>
import {ref, defineProps, computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from 'sweetalert2';
import PointAddForm from "../points/PointAddForm.vue";
import {ElMessageBox} from "element-plus";
import {UploadFilled} from "@element-plus/icons-vue";
const store = useStore();
const router = useRouter();
const showAddFom = ref(false)
const showEditFom = ref(false)
const isLoading = ref(false)
const points = ref([])
const imagesUrl = computed(() => process.env.VUE_APP_URL_API+'/experience_images');
const imageFileList = ref([])
const imageId = ref(null);
const newPoint = ref({
  name: null,
  description: null,
  type: {id: 1},
  longitude: null,
  latitude: null,
  videoUrl: null
});
const setLoadingPoint = (isLoadingPoint) =>{
  isLoading.value = isLoadingPoint
}
const addPoint = (point) =>{
   points.value.push(point)
   showAddFom.value = false
}
const showAddForm = () =>{
  newPoint.value = {
    experience: formModel.value.id,
    name: null,
    description: null,
    type: {id: 1},
    longitude: null,
    latitude: null,
    videoUrl: null
  }
  showAddFom.value = !showAddFom.value
}
const hideAddForm = () =>{
  showAddFom.value = false;
}
const updatePoint = (point) =>{
  showEditFom.value = false
  for (let i = 0; i < points.value.length; i++) {
    if(points.value[i].name === point.name){
      points.value[i] = point
      break
    }
  }
}
const props = defineProps({
   entity: {
     type: Object,
     required: false
   },
  action: {
     type: String,
    required: true
  }
})
const formModel = ref(props.entity|| {});

const trails = computed(() => store.state.trail.trails);
const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');

const getTrails = async () => {
  return await store.dispatch("trail/getTrails");
};

onMounted(async () => {
  await getTrails();
  if (props.entity.trail) {
    if (typeof props.entity.trail === 'object') {
      formModel.value.trail = props.entity.trail.id
    } else if (typeof props.entity.trail === 'string') {
      formModel.value.trail = parseInt(props.entity.trail.split('/').pop())
    }
  }
  if (props.entity.type) {
    formModel.value.type = props.entity.type.id
  }
  if (props.entity.points) {
    points.value = props.entity.points
  }
  if (props.entity.videoImage) {
    formModel.value.videoImage = props.entity.videoImage.id
  }
  if (props.entity.image) {
    imageId.value = props.entity.image.id
    imageFileList.value.push({
      name: props.entity.image.filePath,
      url: props.entity.image.imageUrl
    })
    formModel.value.image = props.entity.image.id
  }
});

const rules = computed(() => {
  return {
    name: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    type: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    trail: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    subtitle: {
      //required: helpers.withMessage("Este campo es obligatorio", required),
    },
    videoUrl: {
      //required: helpers.withMessage("Este campo es obligatorio", required),
    },
    lang: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    latitude: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
    longitude: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
    videoImage: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
    image: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
  };
});
const selectedPoint = ref(null)
const loading = ref(false)
const showEdit = (point) =>{
  selectedPoint.value = null
  selectedPoint.value = point
  showEditFom.value = true
}
const v$ = useVuelidate(rules, formModel, { $scope: 'experience' });
const v = v$.value;

const handleSubmit = () => {
  if (formModel.value.trail) {
    formModel.value.lang = trails.value.find(t => t.id === formModel.value.trail)?.lang || 'es';
  }
  v$.value.$validate();
  if (!v$.value.$invalid) {
    loading.value = true
    formModel.value.points = points.value
    if(props.action === 'create'){
      createEntity(formModel.value);
    }else{
      if(props.entity.id){
        updateEntity(formModel.value);
      }

    }
  }
};

const handleCancel = () => {
  router.push({ name: "Experiencias", params: {} });
};

const updateEntity = async (data) => {
  loading.value = true
  data['trail'] = '/api/trails/'+data.trail
  data['type'] = '/api/experience_types/'+data.type
    await store.dispatch("experience/edit", data).then(async (res) => {
      if (res.status && res.status === 200) {
        await Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Experiencia editada satisfactoriamente.',
          showConfirmButton: false,
          timer: 3000
        })
        selectedPoint.value = null
        loading.value = false
        await router.push({name: "Experiencias", params: {}});
      } else {
        await Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Se ha producido un error.',
          showConfirmButton: false,
          timer: 3000
        });
      }
      loading.value = false
    });
}
const deletePoint = async (id) => {
  try {
     store.dispatch("point/deletePoint", id).then(async () => {
       await router.go({
         name: 'Actualizar-Experiencia',
         params: {id: props.entity.id}
       });
     })

  } catch (error) {
    console.log(error);
  }
};
const handleDelete = (item) => {
  ElMessageBox.confirm("¿Estás seguro que deseas eliminar el registro?")
      .then(() => {
        if(item.id){
          deletePoint(item.id);
        }else{
          let pos = null
          for (let i = 0; i < points.value.length; i++) {
             if(points.value[i].name === item.name){
               pos = i
               break
             }
          }
          points.value.splice(pos, 1);
        }

      })
      .catch(() => {
        // catch error
      });
};
const createEntity = async (data) => {
  await store.dispatch("experience/add", data).then(async (res) => {
    if (res.status === 200 || res.status === 201) {
      await Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Experiencia creada satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      await router.push({name: "Experiencias", params: {}});
    } else {
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: res.response.data['hydra:description'],
        showConfirmButton: false,
        timer: 3000
      })
    }
    loading.value = false
  })
}
const handleImageRemove = () => {
  /*store.dispatch("natural/removeImage", imageId.value).then(()=> {
    imageId.value = null
  })*/
  imageId.value = null
  formModel.value.image = null

}
const imageUploaded = (response) => {
  if(response.id){
    imageId.value = response.id;
    formModel.value.image = imageId.value
  }
}
</script>
<style scoped lang="scss">
 .pointrow{
   display: flex;
   justify-content: flex-end;
 }
 .mrow {
   border-top: 1px solid #d2d6da;
   padding-top: 5px;
   padding-bottom: 5px;
   align-items: center;
 }
 .loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #aa5531;
}

.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #42b983;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
